import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const otherRoutes = [
    {
        path: RouterPaths.PAGE_NOT_FOUND,
        element: importPages.PageNotFound,
    },
];

export default otherRoutes;
